import { TemplateTypes } from '../../../../../../../../../lib/models/TemplateTypes';
import { isLength } from '../../../../../../../../../lib/util/helpers';
import { getFilteredScoringResult, getRulesScoringResult } from '../../../../../utils/end-user-flow-helpers';
import { getRecommendedIndexList } from '../../../utils';

export function getChapterRecommendedProducts(chapter, pagesFlow) {
  const { chapterInnerPagesIds = [] } = chapter;
  const { allPages, answersScoring, rulesProductsProperties } = pagesFlow;

  const chapterPages = allPages.filter(page => Array.isArray(chapterInnerPagesIds) && chapterInnerPagesIds.includes(page.id));

  const chapterElements = chapterPages.flatMap(page => page?.elements || []);

  const productElements = chapterElements.filter(el => el.templateType === TemplateTypes.PRODUCT);
  const products = productElements.flatMap(el => el?.content?.products || []);

  const isChart = isLength(chapterElements.filter(el => el.templateType === TemplateTypes.QUESTION && Array.isArray(el?.content?.chartAnswers)));

  if (!isLength(products)) {
    return { recommendedProductIds: [], hasRecommendedProducts: false };
  }

  const scoringResult = getFilteredScoringResult(answersScoring, pagesFlow, isChart, products);

  const scoringRulesResult = getRulesScoringResult(products, scoringResult, rulesProductsProperties, isChart);

  const structureItemId = productElements[0]?.id;

  const recommendedIndexList = getRecommendedIndexList(products, scoringRulesResult, structureItemId, isChart);

  const recommendedProductIds = recommendedIndexList
    .map(index => products[index])
    .filter(Boolean)
    .map(prod => prod?.productNameSection?.product?.value);

  return {
    recommendedProductIds,
    hasRecommendedProducts: recommendedProductIds.length > 0,
  };
}
